export default __webpack_public_path__ + "locales/sq-AL/MainBar.json?hash=52055b5ad141551bcc24524b55bcdf8b";